import { ConfigProvider } from 'antd';

import { Colors } from './themes/colors';

const AntdProvider = ({ children }: { children: React.ReactNode }) => (
	<ConfigProvider
		theme={{
			token: {
				colorPrimary: Colors.palette.primary,
				borderRadius: 4,
				colorTextDisabled: Colors.palette.colorTextDisabled,
				colorBorder: Colors.palette.colorBorder,
				colorBgContainerDisabled: Colors.palette.colorBgContainerDisabled,
				fontFamily: 'inherit',
				colorError: Colors.palette.red7,
				colorText: Colors.palette.font1,
				fontSize: 13,
			},
			components: {
				Select: {
					controlItemBgActive: Colors.palette.blue6,
					controlItemBgHover: Colors.palette.blue6,
				},
				Dropdown: {
					controlItemBgActive: Colors.palette.blue6,
					controlItemBgHover: Colors.palette.blue6,
				},
				Checkbox: {
					controlInteractiveSize: 16,
					borderRadius: 2,
				},
			},
		}}
	>
		{children}
	</ConfigProvider>
);

export default AntdProvider;
